<template>
  <report
    ref="report"
    :title="$t('language.dailyattendance')"
    :filter="filter"
    :url="url"
  >
    <template v-slot:filter>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.fromdate')"
          rules="required"
          v-slot="{ errors }"
        >
          <eng-nep-date-picker
            :error-messages="errors[0]"
            v-model="filter.fromdate"
            :label="$t('language.fromdate')"
          ></eng-nep-date-picker>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.todate')"
          rules="required"
          v-slot="{ errors }"
        >
          <eng-nep-date-picker
            :error-messages="errors[0]"
            v-model="filter.todate"
            :label="$t('language.todate')"
          ></eng-nep-date-picker>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.branchid"
          :items="BranchList"
          item-text="name"
          item-value="id"
          :label="$t('language.branch')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.departmentid"
          :items="DepartmentList"
          item-text="name"
          item-value="id"
          :label="$t('language.department')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.designationid"
          :items="DesignationList"
          item-text="name"
          item-value="id"
          :label="$t('language.designation')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.modeid"
          :items="ModeList"
          item-text="name"
          item-value="id"
          :label="$t('language.mode')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.personid"
          :items="PersonList"
          item-text="name"
          item-value="id"
          :label="$t('language.person')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <ValidationProvider
          :name="$t('language.attendancetype')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.attendancetype"
            :items="AttendanceTypeList"
            item-text="name"
            item-value="id"
            :label="$t('language.attendancetype')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
    </template>
    <template v-slot:printheader>
      <div class="v-data-table">
        <div class="v-data-table__wrapper">
          <table class="w-100">
            <tbody>
              <tr>
                <td>{{ $t("language.fromdate") }}:{{ selectedfromdate }}</td>
                <td></td>
                <td>{{ $t("language.todate") }}:{{ selectedtodate }}</td>
                <td></td>
                <td>{{ $t("language.branch") }}:{{ selectedbranch }}</td>
                <td></td>
                <td>
                  {{ $t("language.department") }}:{{ selecteddepartment }}
                </td>
                <td></td>
                <td>
                  {{ $t("language.designation") }}:{{ selecteddesignation }}
                </td>
                <td></td>
                <td>{{ $t("language.mode") }}:{{ selectedmode }}</td>
                <td></td>
                <td>{{ $t("language.person") }}:{{ selectedperson }}</td>
                <td></td>
                <td>
                  {{ $t("language.attendancetype") }}:{{
                    selectedattendancetype
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <template v-slot:table="{ data }">
      <table
        class="table table-bordered w-100"
        v-if="
        filter.attendancetype == 'attendance' ||
          filter.attendancetype == 'present' ||
            filter.attendancetype == 'lateinearlyout'
        "
      >
        <thead>
          <tr>
            <th>{{ $t("language.name") }}</th>
            <th>{{ $t("language.date") }}</th>
            <th>{{ $t("language.day") }}</th>
            <th>{{ $t("language.dutyhour") }}</th>
            <th>{{ $t("language.intime") }}</th>
            <th v-if="$store.getters.settings.enablebreakinbreakout">
              {{ $t("language.breakout") }}
            </th>
            <th v-if="$store.getters.settings.enablebreakinbreakout">
              {{ $t("language.breakin") }}
            </th>
            <th>{{ $t("language.outtime") }}</th>
            <th>{{ $t("language.workedhour") }}</th>
            
            <th>{{ $t("language.latein") }}</th>
            <th>{{ $t("language.earlyout") }}</th>
            <th v-if="$store.getters.settings.enableot">
              {{ $t("language.ot") }}
            </th>
            <th>{{ $t("language.status") }}</th>
            <th>{{ $t("language.remarks") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.name }}</td>
            <td>{{ getDefaultDate(item.date) }}</td>
            <td>{{ $t("language." + item.day) }}</td>
            <td>{{ item.officehour }}</td>
            <td>{{ item.intime }}</td>
            <td v-if="$store.getters.settings.enablebreakinbreakout">
              {{ item.breakouttime }}
            </td>
            <td v-if="$store.getters.settings.enablebreakinbreakout">
              {{ item.breakintime }}
            </td>
            <td>{{ item.outtime }}</td>
            <td>{{ item.workedhour }}</td>
            
            <td>{{ item.latein }}</td>
            <td>{{ item.earlyout }}</td>
            <td v-if="$store.getters.settings.enableot">{{ item.othour }}</td>
            <td>{{ item.status != "" ? $t("language." + item.status.toLowerCase()) : "" }}</td>
            <td></td>
          </tr>
        </tbody>
        <tfoot v-if="data.length == 0">
          <tr>
            <th :colspan="colspan">{{ $t("language.nodatafound") }}</th>
          </tr>
        </tfoot>
      </table>
      <table
        class="table table-bordered w-100"
        v-if="
        filter.attendancetype != 'attendance' &&
          filter.attendancetype != 'present' &&
            filter.attendancetype != 'lateinearlyout'
        "
      >
        <thead>
          <tr>
            <th>{{ $t("language.date") }}</th>
            <th>{{ $t("language.name") }}</th>
            <th>{{ $t("language.designation") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ getDefaultDate(item.date) }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.designation }}</td>
          </tr>
        </tbody>
        <tfoot v-if="data.length == 0">
          <tr>
            <th colspan="3">{{ $t("language.nodatafound") }}</th>
          </tr>
        </tfoot>
      </table>
    </template>
  </report>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Report from "../Report";
import EngNepDatePicker from "../../../../components/shared/EngNepDatePicker";
import commonservice from "../../../../shared/common.service";
export default {
  components: {
    Report,
    EngNepDatePicker,
  },
  data() {
    return {
      filter: {
        fromdate: moment().format("YYYY-MM-DD"),
        todate: moment().format("YYYY-MM-DD"),
        branchid: null,
        departmentid: null,
        designationid: null,
        modeid: null,
        personid: null,
        attendancetype: 'attendance',
      },
      BranchList: [],
      DepartmentList: [],
      DesignationList: [],
      ModeList: [],
      PersonList: [],
      AttendanceTypeList: commonservice.AttendanceTypeList,
      url: "client/report/daily/attendances",
    };
  },
  computed: {
    colspan() {
      let colspan = 10;
      if (this.$store.getters.settings.enablebreakinbreakout) colspan += 2;
      if (this.$store.getters.settings.enableot) colspan += 1;
      return colspan;
    },
    selectedfromdate() {
      return commonservice.getDefaultDate(this.filter.fromdate);
    },
    selectedtodate() {
      return commonservice.getDefaultDate(this.filter.todate);
    },
    selectedbranch() {
      if (this.filter.branchid == null) return this.$t("language.all");
      return this.BranchList.filter((c) => {
        return c.id == this.filter.branchid;
      })[0].name;
    },
    selecteddepartment() {
      if (this.filter.departmentid == null) return this.$t("language.all");
      return this.DepartmentList.filter((c) => {
        return c.id == this.filter.departmentid;
      })[0].name;
    },
    selecteddesignation() {
      if (this.filter.designationid == null) return this.$t("language.all");
      return this.DesignationList.filter((c) => {
        return c.id == this.filter.designationid;
      })[0].name;
    },
    selectedmode() {
      if (this.filter.modeid == null) return this.$t("language.all");
      return this.ModeList.filter((c) => {
        return c.id == this.filter.modeid;
      })[0].name;
    },
    selectedperson() {
      if (this.filter.personid == null) return this.$t("language.all");
      return this.PersonList.filter((c) => {
        return c.id == this.filter.personid;
      })[0].name;
    },
    selectedattendancetype() {
      if (this.filter.attendancetype == null) return this.$t("language.all");
      return this.AttendanceTypeList.filter((c) => {
        return c.id == this.filter.attendancetype;
      })[0].name;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/report/daily/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.DesignationList = response.data.designations;
        p.ModeList = response.data.modes;
        p.PersonList = response.data.persons;

        p.filter.attendancetype = to.query.type;
        p.filter.branchid = to.query.branchid;
        if (to.query.type != null) {
          p.$refs.report.filterData();
        }
      });
    });
  },
  methods: {
    getDefaultDate(date) {
      return commonservice.getDefaultDate(date);
    },
  },
};
</script>
